import React, { useContext } from 'react';
import store from '../../store';
// Custom components
import { DefaultButton } from '../Buttons';
// Material components
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@material-ui/core';
// Styles
import withWidth from '@material-ui/core/withWidth';
import { flex } from '../../assets/jss';

const Terms = (props) => {
    const { width } = props;
    // const classes = useStyles();
    const { reducers, modals } = useContext(store);

    const handleSubmit = (value) => () => {
        reducers.acceptTerms(value)
    }

    const Body = () => {
        return (
            <React.Fragment>
                <DialogTitle id="form-dialog-title">Code of conduct</DialogTitle>
                <DialogContent>
                    <Typography paragraph>
                        This website is NOT suitable for children. By its very nature, a collaborative writing project
                        invites profanity. I DO NOT promote it and in my honest opinion, it shows a lack of imagination.
                        A part of the freedom of expression is to sometimes allow for profane thoughts to be expressed.
                        I have therefore not applied any profanity filters to censor anyone's contributions.
               </Typography>
                    <Typography paragraph>
                        That being said, as author and admin of this site, I reserve the right to remove any contributions
                        that I deem excessively rude, racist or profane. Writing something rude with many swear words is easy,
                        but stupid. If it becomes clear that this freedom of expression is being abused by too many people,
                        profanity filters will be applied and users will be deleted.
                </Typography>
                    <Typography paragraph>
                        Please try to connect with your creative self, forget your ego, and try to add something meaningful!
                </Typography>
                </DialogContent>
                <DialogActions style={flex.flex_row_center}>
                    <DefaultButton variant='dark' children='I Agree' onClick={handleSubmit(true)} />
                    <DefaultButton variant='light' children='No Thanks' onClick={handleSubmit(false)} />
                </DialogActions>
            </React.Fragment>
        )
    }

    return (

        <React.Fragment>
            {width === 'xs'
                ? <Dialog
                    open={modals.terms}
                    fullScreen
                    maxWidth='sm'
                    scroll='body'
                    aria-labelledby="form-dialog-title">
                    <Body />
                </Dialog>
                : <Dialog
                    open={modals.terms}
                    maxWidth='sm'
                    scroll='body'
                    aria-labelledby="form-dialog-title">
                    <Body />
                </Dialog>
            }
        </React.Fragment>
    );
}

export default withWidth()(Terms)